import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { getListServiceAuthenticate } from '../Controllers/menuApis';
import { notification } from '../../StyleShare';

import '../Asset/style.scss';

const MenuPermission = ({token, header}) => {
    const uploadImageDomain = process.env.REACT_APP_URL_API_UPLOAD;

    // configure data

    const [dataService, setDataService] = useState([]);

    // configure data

    // call api

    const handleGetListServiceAuthenticate = async () => {
        try {
            const result = await getListServiceAuthenticate(header);
            if (result.status === 200) {
                setDataService(result.data);
            } else {
                toast.error(result.message, notification);
            }
        } catch (error) {
            console.log(error);
        }
    };

    // call api

    useEffect(() => {
        if (token) {
            handleGetListServiceAuthenticate();
        }
    }, [token]);

    return (
        <div className='menu-permission-container'>
            <div className='menu-permission-icon-menu'>
                <img src={require('../Asset/icon_menu.png')} alt='iconmenu' />
            </div>
            {dataService && dataService.length > 0 && (
                <div className='menu-permission-content'>
                    <div className='menu-permission-list-item'>
                        {dataService.map((service, index) => {
                            return ( service &&
                                <a href={service.domain} key={index} className='menu-permission-item'>
                                    <div className='menu-permission-item-wrapper'>
                                        <div className='menu-permission-item-icon'>
                                            {service.iconUrl ? <img
                                                src={`${uploadImageDomain}${service.iconUrl}`}
                                                alt='iconmenu'
                                            /> : <img
                                                src={require('../Asset/def_logo.png')}
                                                alt='iconmenu'
                                            />}
                                            
                                        </div>
                                        <div className='menu-permission-item-name'>
                                            <span>{service.name}</span>
                                        </div>
                                    </div>
                                </a>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MenuPermission;
